export default __webpack_public_path__ + "static/media/45-percent-com.9d925c17.webp";